import { Component, OnInit } from '@angular/core';
import {
  ChargeInformationCollectionDto,
  ChargeInformationDto,
  ChargeInformationService,
  ChargeType,
  MeteringPointChargeInformationService
} from '@app/api/dmc';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormApiService } from '@app/core/services/form-api.service';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { SelectDirective } from '@shared/components/input/select/select.directive';
import { enumToKeyValue } from '@app/core/utils/enum-to-key-value';
import { KeyValue } from '@shared/interfaces/key-value/key-value';
import { InputDateDirective } from '@shared/components/input/date/input-date.directive';
import { AlertService } from '@app/core/services/alert.service';
import { HasUnsavedChanges } from '@app/core/guards/unsaved-changes.guard';

@Component({
  selector: 'app-associate-charge-information',
  imports: [
    InputDirective,
    InputGroupComponent,
    LabelDirective,
    ReactiveFormsModule,
    TranslatePipe,
    SelectDirective,
    InputDateDirective
  ],
  templateUrl: './associate-charge-information.component.html',
  styleUrl: './associate-charge-information.component.css'
})
export class AssociateChargeInformationComponent implements OnInit, HasUnsavedChanges {
  public hasUnsavedChanges(): boolean {
    return this.form.dirty;
  }

  public identification?: string;
  public chargeInformations: ChargeInformationDto[] = [];

  public chargeInformationList: KeyValue[] = enumToKeyValue(ChargeType, { omitKeys: ['NotSpecified'], prefixValue: 'chargeInformation.chargeTypes.'})
  public chargeInformationIdList: KeyValue[] = [];


  public form: FormGroup = new FormGroup({
    meteringPointIdentification: new FormControl(null, Validators.required),
    validFrom: new FormControl(null, Validators.required),
    chargeTypeId: new FormControl(null, Validators.required),
    chargeType: new FormControl(null, Validators.required),
    chargeOccurrences: new FormControl(1, Validators.required)
  })

  constructor(
    private readonly chargeInformationService: ChargeInformationService,
    private readonly formApiService: FormApiService,
    private readonly meteringPointChargeInformationService: MeteringPointChargeInformationService,
    private readonly alertService: AlertService,
  ) {

  }

  public ngOnInit(): void {
    if (this.identification) {
      this.form.get('meteringPointIdentification')?.setValue(this.identification);
    }

    this.form.get('chargeType')?.valueChanges.subscribe((value) => {
      this.form.get('chargeTypeId')?.reset();

      this.mapChargeInformationToKeyValue()

      if (value !== ChargeType.Subscription) {
        this.form.get('chargeOccurrences')?.setValue(1);
      }
    })

    this.form.get('chargeType')?.valueChanges.subscribe((value: ChargeType) => {
      this.chargeInformationService.chargeInformationQueryPost({
        latestConfirmed: true,
        ownership: true,
        chargeType: value,
      }).subscribe(
        (data: ChargeInformationCollectionDto) => {
          if (data.results && data.results.length > 0) {
            this.alertService.clearAll();
            this.chargeInformations = data.results;

            this.mapChargeInformationToKeyValue()
          } else {
            this.alertService.open('modal', 'danger', 'chargeInformation.noChargeInformationFound')
          }
        }
      )
    })


  }

  private mapChargeInformationToKeyValue(): void {
    this.chargeInformationIdList = this.chargeInformations.map((element: ChargeInformationDto) => ({ key: element.chargeTypeId, value: `${element.chargeTypeId} - ${element.description}` }) as KeyValue)
  }

  private fetchChargeInformationFromId(id: string): ChargeInformationDto {
    return this.chargeInformations.find((element: ChargeInformationDto) => element.id === id) as ChargeInformationDto;
  }

  public create(): void {
    this.formApiService.submit(
      this.form,
      (data) => this.meteringPointChargeInformationService.meteringPointChargeInformationAssociatePost(data),
      {
        successMessage: 'chargeInformation.associateChargeInformationSuccesful',
        closeModal: true,
      }
    );
  }
}
